import api from '../utils/api'; // Assuming you have an API utility

const permissionService = {
  // Permission CRUD
  getPermissions: (params) => api.get('/admin/permissions', { params }),
  getPermissionModules: () => api.get('/admin/permissions/modules'),
  createPermission: (data) => api.post('/admin/permissions', data),
  deletePermission: (id) => api.delete(`/admin/permissions/${id}`),
  fetchPermission: (id) => api.get(`/admin/permissions/${id}`),
  updatePermission: (id, data) => api.put(`/rbac/permissions/${id}`, data),
};

export default permissionService;